import { render, staticRenderFns } from "./ProductClassifyEdit.vue?vue&type=template&id=1313f774&scoped=true&"
import script from "./ProductClassifyEdit.vue?vue&type=script&lang=js&"
export * from "./ProductClassifyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1313f774",
  null
  
)

export default component.exports